/**
 * Shared constants used by both React components and the vanilla JS playerTemplate.
 * Single source of truth — update here, not in individual files.
 */

/** Approval status → color mapping for pills, dots, and comment markers */
export const APPROVAL_COLORS: Record<string, string> = {
  pending: '#888',
  approved: '#4caf50',
  notes: '#f5c542',
};

/** Layout dimensions (px) matching CSS custom properties in global.css / playerTemplate */
export const LAYOUT = {
  TRANSPORT_HEIGHT: 48,
  RULER_HEIGHT: 24,
  SHOT_LANE_HEIGHT: 80,
  AUDIO_LANE_HEIGHT: 80,
  COMMENTS_PANEL_WIDTH: 280,
  SHOT_BAR_GAP_INSET: 10,
} as const;

/** Audio lane names (ordered by lane index) */
export const AUDIO_LANE_NAMES = ['DIA', 'MUS', 'SFX', 'VO'] as const;

/** Audio lane height per sub-lane (px) */
export const AUDIO_SUBLANE_HEIGHT = 20;
